import { Question } from '@staffino/model';

export default function getQuestionType(question: Question) {
  if (question.metric) {
    if (question.metric === 'CSAT') {
      return 'CSAT';
    }
    if (question.metric === 'CES') {
      return 'CES';
    }
    if (question.metric === 'FCR') {
      return 'FCR';
    }
    if (question.metric === 'NPS') {
      return 'NPS';
    }
    if (question.metric === 'CXJ') {
      return 'CXJ';
    }
  }
  if (
    question.type === 'Scale' &&
    ['Binary', 'YesNo', 'yesno'].includes(question.skin)
  ) {
    return 'Sentiment';
  }
  if (question.type === 'Scale') {
    return 'Rating';
  }
  if (question.type === 'Choice') {
    return 'Choice';
  }
  if (question.type === 'Text') {
    return 'Text';
  }
  return undefined;
}
